import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { HOVER } = SNOWPLOW_EVENTS;

export const triggerSellerMessagingSubjectTooltipHoveredEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		name: 'dlr_seller_messaging_subject_tooltip_hovered',
		schemaName: HOVER.SCHEMA,
		version: HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
